import { makeStyles } from "@material-ui/styles";

const boxScoreStyles = makeStyles((theme) => ({
	content: {
		overflow: "auto"
	},
	selectedTeam: {
		borderBottom: "2px solid #D10B0B",
		borderRadius: "2px"
	},
	inProgress: {
		color: theme.palette.primary.main
	},
	final: {
		color: theme.palette.gameMode.ternary
	},
	header: {
		textTransform: "uppercase"
	},
	row: {
		height: 50
	},
	sectionTitle: {
		padding: "20px 0"
	},
	textBold: {
		fontWeight: "bold"
	},
	pageBreak: {
		"@media print": {
			pageBreakInside: "avoid"
		}
	},
	tablePrintFriendly: {
		"& thead tr th": {
			pageBreakInside: "avoid"
		},
		"& tbody tr td": {
			pageBreakInside: "avoid"
		}
	},
	nonPrintable: {
		"@media print": {
			display: "none"
		}
	},
	playerCard: {
		minHeight: 115
	},
	playerCardContent: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center"
	},
	tableText: {
		"& td": {
			textAlign: "center"
		},
		"& th": {
			textAlign: "center"
		}
	},
	evenPlayerListItem: {
		backgroundColor: "rgba(0, 0, 0, 0.12)"
	},
	toggleButtonBox: {
		display: "flex",
		alignItems: "center",
		gap: 5,
		[theme.breakpoints.only("xs")]: {
			flexDirection: "column"
		}
	}
}));

export default boxScoreStyles;
